import { render } from "./AddNewCategory.vue?vue&type=template&id=ca5f6314&scoped=true"
import script from "./AddNewCategory.vue?vue&type=script&lang=js"
export * from "./AddNewCategory.vue?vue&type=script&lang=js"

import "./AddNewCategory.vue?vue&type=style&index=0&id=ca5f6314&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5f6314"]])

export default __exports__